import { atom } from "jotai";

interface User {
    isLoaded: boolean
    name: string
    roles: string[]
    nickname?: string
}

export const userAtom = atom<User>({
    isLoaded: false,
    name: '',
    nickname: undefined,
    roles: []
})

export const updateUserAtom = atom(null, (get, set, newUser: User) => {
    set(userAtom, newUser)
})

export const userIsLoadedAtom = atom((get) => get(userAtom).isLoaded)

export const userNameAtom = atom((get) => {
    const user = get(userAtom)
    return user.nickname || user.name
})